enum JobStatus {
    FAILED = 'failed',
    NO_EXPORT = 'no_export',
    RUNNING = 'running',
    SUCCESS = 'success',
}
export default JobStatus;
